const ThemeStatusType = Object.freeze({
  ACTIVE: 'Active',
  BUILDING: 'Building',
  FAILED: 'Failed'
})
export default ThemeStatusType
// RESERVE BELOW
